function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f26f4d;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "sms");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.86,47.91H4.07V10.68h18.6V6.61H2a2,2,0,0,0-2,2V58a2,2,0,0,0,2,2H33.9a2,2,0,0,0,2-2V27.38l-4.07,2.33v18.2ZM18,50.51a3.14,3.14,0,1,1-3.14,3.14A3.13,3.13,0,0,1,18,50.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M50.64,0H27.15a3.3,3.3,0,0,0-3.3,3.3v15a3.3,3.3,0,0,0,3.3,3.3h3.53l-2.6,5.23a.73.73,0,0,0,.61,1.13.76.76,0,0,0,.41-.13L40,21.55H50.64a3.3,3.3,0,0,0,3.3-3.3V3.3A3.3,3.3,0,0,0,50.64,0ZM32.32,13.24a2.47,2.47,0,1,1,2.46-2.46A2.46,2.46,0,0,1,32.32,13.24Zm6.57,0a2.47,2.47,0,1,1,2.47-2.46A2.46,2.46,0,0,1,38.89,13.24Zm6.58,0a2.47,2.47,0,1,1,2.47-2.46A2.47,2.47,0,0,1,45.47,13.24Z"
})));

var SvgSms = function SvgSms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53.94 60",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sms.4422a488.svg";
export { ForwardRef as ReactComponent };